import { Injectable, signal } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class AppReviewManagerService {

  private static readonly ACTIVITY_COUNT_KEY = 'reviewActivityCount';
  private static readonly FEEDBACK_GIVEN_KEY = 'feedbackGiven';
  private static readonly FEEDBACK_DISMISSED_KEY = 'feedbackDismissed';

  private static readonly MIN_ACTIVITY_COUNT = 3;

  readonly showSurvey = signal(false);

  registerActivity(): void {
    const currentCount = this.getActivityCount();
    localStorage.setItem(AppReviewManagerService.ACTIVITY_COUNT_KEY, String(currentCount + 1));
  }

  shouldShowSurvey(isFeatureFlagEnabled: boolean): boolean {
    if (this.hasFeedbackBeenGiven()) {
      return false;
    }

    if (this.hasFeedbackBeenDismissed()) {
      return false;
    }

    if (this.getActivityCount() < AppReviewManagerService.MIN_ACTIVITY_COUNT) {
      return false;
    }

    if (!isFeatureFlagEnabled) {
      return false;
    }

    return true;
  }

  checkAndTriggerSurvey(isFeatureFlagEnabled: boolean): void {
    this.showSurvey.set(this.shouldShowSurvey(isFeatureFlagEnabled));
  }

  markFeedbackGiven(): void {
    localStorage.setItem(AppReviewManagerService.FEEDBACK_GIVEN_KEY, 'true');
    this.showSurvey.set(false);
  }

  markFeedbackDismissed(): void {
    localStorage.setItem(AppReviewManagerService.FEEDBACK_DISMISSED_KEY, 'true');
    this.showSurvey.set(false);
  }

  resetDismissedState(): void {
    localStorage.removeItem(AppReviewManagerService.FEEDBACK_DISMISSED_KEY);
  }

  getActivityCount(): number {
    const stored = localStorage.getItem(AppReviewManagerService.ACTIVITY_COUNT_KEY);
    return stored ? parseInt(stored, 10) || 0 : 0;
  }

  private hasFeedbackBeenGiven(): boolean {
    return localStorage.getItem(AppReviewManagerService.FEEDBACK_GIVEN_KEY) === 'true';
  }

  private hasFeedbackBeenDismissed(): boolean {
    return localStorage.getItem(AppReviewManagerService.FEEDBACK_DISMISSED_KEY) === 'true';
  }

  clearReviewData(): void {
    localStorage.removeItem(AppReviewManagerService.ACTIVITY_COUNT_KEY);
    localStorage.removeItem(AppReviewManagerService.FEEDBACK_GIVEN_KEY);
    localStorage.removeItem(AppReviewManagerService.FEEDBACK_DISMISSED_KEY);
    this.showSurvey.set(false);
  }

  forceShowSurvey(): void {
    localStorage.removeItem(AppReviewManagerService.FEEDBACK_GIVEN_KEY);
    localStorage.removeItem(AppReviewManagerService.FEEDBACK_DISMISSED_KEY);
    localStorage.setItem(AppReviewManagerService.ACTIVITY_COUNT_KEY, '3');
    this.showSurvey.set(true);
  }
}
